import { PlessResponderSub } from './../../../../commons/kymw00/pless-responder-sub.service';
import { KYMW1001Model } from '../kymw1001.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * トップ画面お知らせを取得するサービス
 *
 * @export GetPageSettingService
 * @class GetPageSetting
 * @extends {PlessResponder}
 */
@Injectable()
export class GetPageSettingService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW1001Model = null;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPageSettingService
   */
  private successFunc: (model: any[]) => void = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @memberof GetPageSettingService
   */
  execute(model: KYMW1001Model, successFunc: (model: any[]) => void): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW02getPageCntList', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPageSettingService
   */
  success(data: any): void {
    if (data != null && this.successFunc) {
      this.successFunc(data);
    }
  }
}
